import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import ReactHtmlParser from "react-html-parser";

function SEO({ url, location, ogImage, lang, hrefLang, pageTitle }) {
  const BASE_URL = "https://www.airasia.com/aa/restaurant-lists";

  var title, description, keywords;

  // for homepage
  if (url === "/") {
    title = `Partner with airasia food to grow your business like our Merchants | airasia.com`;
    description = `Business made easier with airasia food. Reach more consumers with an online food delivery! 100+ restaurant partners grow their online sales by joining airasia Food Merchant partner now!`;
    keywords = `online restaurant, airasia food merchant, food merchant, food partner, delivery food partner, partner with airasia`;
  }
  // } else if (url === '/th/th/') {
  //   title = `ค้นหาโรงแรมและรีสอร์ททั่วโลก | airasia.com`;
  //   description = `พบโปรโมชั่นโรงแรมและรีสอร์ทหรูทั่วโลก พร้อมรับส่วนลดมากมายสำหรับห้องพักและโรงแรมทุกระดับที่ airasia.com`;
  //   keywords = `โรงแรมหรู, โรงแรมดัง, โรงแรมชื่อดังระดับโลก, โรงแรม 5 ดาว, โรงแรม 4 ดาว, โรงแรมราคาประหยัด,​ บูทีคโฮเทล, บูติคโฮเทล, รีสอร์ทหรู, รีสอร์ทดัง, รีสอร์ทยอดนิยม, โรงแรมถูก, รีสอร์ทราคาถูก`;
  // }
  // else if (url.includes('/th/th/')) {
  //   title = `ท๊อป 10 โรงแรมและรีสอร์ทที่ดีที่สุดใน ${location}`;
  //   description = `ประหยัดสุดๆ กับโรงแรมและรีสอร์ทที่ดีที่สุดใน ${location} พร้อมรับส่วนลดสำหรับห้องพักมากมายใน ${location} ที่ airasia.com `;
  //   keywords = ` ${location} โรงแรม, โรงแรมดีที่สุดใน ${location}, โรงแรมดังใน ${location}, โรงแรมหรูใน ${location}, โรงแรมท๊อป 10 ใน ${location}, โรงแรม 5 ดาวใน ${location}, โรงแรม 4 ดาวใน ${location}, โรงแรม 3 ดาวใน ${location}, โรงแรมราคาประหยัดใน ${location}, บันยันทรี ${location}, มิลเลนเนียมฮิลตัน ${location}, แมนดาริน โอเรียนเต็ล ${location}, แชงกรีล่า ${location}, โนโวเทล ${location}, พาร์คไฮแอท ${location}, วอลดอร์ฟ แอสทอเรีย ${location}, โซ โซฟิเทล ${location}`;
  // }
  else {
    title = `Choose ${pageTitle}'s menu and get delivered with airasia food  `;
    description = `Check the menu of your favourite ${pageTitle}'s restaurant and get the food delivered to your doorstep, ${pageTitle}'s promos are awaiting you. Order $${pageTitle}'s delivery now with airasia!`;
    keywords = `${pageTitle}`;
  }
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      link={[
        {
          rel: "canonical",
          href: BASE_URL + url,
        },
      ]}
      meta={[
        {
          name: `description`,
          content: description,
        },
        {
          name: `robots`,
          content:
            process.env.GATSBY_ENV === "stg"
              ? "nofollow, noindex"
              : "follow, index",
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:url`,
          content: BASE_URL + url,
        },
        {
          property: `og:image`,
          content: ogImage,
        },
        {
          property: `og:description`,
          content: description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:locale`,
          content: `en-GB`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:image`,
          content: ogImage,
        },
        {
          name: `twitter:site`,
          content: "@airasia.com",
        },
        {
          name: `twitter:description`,
          content: description,
        },
      ]}
    >
      <link rel="canonical" href={BASE_URL+url} />
      {ReactHtmlParser(hrefLang)}
    </Helmet>
  );
}

SEO.defaultProps = {
  lang: "en",
  description: "",
  title: "",
  keywords: "",
  ogImage: "https://a.staticaa.com/images/misc/aa_everyone.jpg",
  url: "",
};

SEO.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  keywords: PropTypes.string,
  ogImage: PropTypes.string,
  url: PropTypes.string,
};

export default SEO;
